// ============================================================
// constants.js — Constantes globales de l'application AVALIST
// Centralise toutes les valeurs fixes utilisées dans les filtres
// et les couleurs, pour éviter les "magic numbers" dans le code.
// ============================================================

// --- Filtres de la navbar (état du contrôle des parcs) ---
export const FILTER_DONE     = 0; // Contrôle effectué (date favorable non dépassée)
export const FILTER_NEEDED   = 1; // Contrôle nécessaire (date favorable dépassée)
export const FILTER_URGENT   = 2; // Contrôle urgent (date maximale dépassée)
export const FILTER_ALL      = 3; // Tous les parcs sans filtrage
export const FILTER_STANDBY  = 4; // Parcs mis en standby (suspension temporaire)

// --- Codes couleur pour les pastilles carte et les bandes de la liste ---
export const COLOR_RED    = 0; // Rouge   : contrôle en retard critique (> 15 mois)
export const COLOR_GREEN  = 1; // Vert    : contrôle à jour (< 12 mois)
export const COLOR_ORANGE = 2; // Orange  : contrôle souhaitable (entre 12 et 15 mois)
export const COLOR_PURPLE = 3; // Violet  : parc en standby

